/*
 * HolyShape collection grid.
 * - Category tabs: only the active tab is in the page; other tabs are fetched on tap
 *   through the section rendering API and kept for the rest of the visit.
 * - "Show more" / infinite scroll: next page fetched with ?section_id=, cards appended.
 * - Card: colour swatches, size pills, add to cart through the hidden <product-form>
 *   (so the cart drawer opens and hs-preorder.js sees a real /cart/add form submit).
 * - Quick view and size guide modals.
 * - Pre-order: the add button reads the PO app (same endpoints hs-preorder.js uses).
 */
(function () {
  if (window.__hsCollection) return;
  window.__hsCollection = true;

  var TEXT = {
    add: 'В Кошик-->', sold: 'РОЗПРОДАНО', sizeGuide: 'РОЗМІРНА СІТКА', details: 'ПЕРЕГЛЯНУТИ ДЕТАЛЬНІШЕ',
    loading: 'ЗАВАНТАЖЕННЯ...', adding: 'Додаємо...', variant: 'Варіант', preorder: 'Передзамовлення', close: 'Закрити'
  };
  function readText() {
    var el = document.querySelector('[data-hs-collection-text]');
    if (!el) return;
    try {
      var t = JSON.parse(el.textContent);
      Object.keys(t).forEach(function (k) { if (t[k]) TEXT[k] = t[k]; });
    } catch (e) {}
  }

  function withSection(url, sectionId) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
  }
  function sectionIdOf(el) {
    var root = el.closest('[data-section-id]');
    return root ? root.getAttribute('data-section-id') : '';
  }
  function fetchDoc(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
  }

  /* ---------------- Pre-order ---------------- */
  var PRE = null;
  var SET = {};
  function isPre(vid) {
    if (!PRE || !vid) return null;
    var p = PRE[String(vid)];
    if (!p) return null;
    if (p.inventory !== null && p.inventory !== undefined && p.inventory > 0) return null;
    return p;
  }
  function fmtEta(eta) {
    if (!eta) return '';
    var p = String(eta).split('-');
    try {
      return new Date(+p[0], +p[1] - 1, +p[2]).toLocaleDateString(SET.language || document.documentElement.lang || 'uk', {
        year: 'numeric', month: 'long', day: 'numeric'
      });
    } catch (e) { return eta; }
  }
  function preLabel(eta) {
    return String(SET.button_text || TEXT.preorder).replace(/\{\{\s*eta\s*\}\}/g, fmtEta(eta));
  }
  function loadPreorder() {
    var api = window.__HS_PREORDER_API;
    if (!api) return;
    fetch(api).then(function (r) { return r.json(); }).then(function (d) {
      PRE = (d && d.variants) || {};
      refreshAll(document);
    }).catch(function () {});
    var sapi = window.__HS_PREORDER_SETTINGS_API;
    if (sapi) {
      fetch(sapi).then(function (r) { return r.json(); }).then(function (s) {
        SET = s || {};
        if (SET.color_primary) document.documentElement.style.setProperty('--hs-po-accent', SET.color_primary);
        refreshAll(document);
      }).catch(function () {});
    }
  }

  /* ---------------- Card state ---------------- */
  function setText(el, txt) { if (el.textContent !== txt) el.textContent = txt; }
  function setButton(btn, vid, available) {
    var p = isPre(vid);
    btn.classList.toggle('is-preorder', !!p);
    btn.classList.toggle('is-sold', !p && !available);
    setText(btn, p ? preLabel(p.eta) : (available ? TEXT.add : TEXT.sold));
  }
  function activePill(card) {
    return card.querySelector('.size-pill.active:not([hidden])') || card.querySelector('.size-pill.active');
  }
  function refreshCard(card) {
    var btn = card.querySelector('[data-hs-add]');
    if (!btn || btn.disabled) return;
    var pill = activePill(card);
    var available = pill ? pill.getAttribute('data-available') === 'true' : !btn.classList.contains('is-sold');
    setButton(btn, btn.getAttribute('data-variant-id'), available);
  }
  function refreshAll(root) {
    (root || document).querySelectorAll('.hsc-cc').forEach(refreshCard);
  }
  // hs-preorder.js ignores DOM additions under any element whose class contains " hs-"
  // (and <html> carries "hs-np-on"), so it never sees cards we add. It does rescan on a
  // click inside .custom-card-swatches: send it one from a throwaway node.
  function nudgePreorder() {
    var n = document.createElement('span');
    n.className = 'custom-card-swatches';
    n.hidden = true;
    document.body.appendChild(n);
    n.dispatchEvent(new MouseEvent('click', { bubbles: true }));
    n.remove();
    // Judge.me only sets up the star badges it found at page load; cards that
    // arrive later keep their badge hidden until it is asked again.
    if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
      try { window.jdgm.customizeBadges(); } catch (e) { /* stars are optional */ }
    }
  }
  function setImage(card, src) {
    if (!src) return;
    var img = card.querySelector('.hsc-cc__img:not(.hsc-cc__img--hover)');
    if (!img) return;
    img.removeAttribute('srcset');
    img.src = src;
  }
  function selectPill(card, pill) {
    card.querySelectorAll('.size-pill').forEach(function (p) { p.classList.toggle('active', p === pill); });
    var btn = card.querySelector('[data-hs-add]');
    if (btn) btn.setAttribute('data-variant-id', pill.getAttribute('data-variant-id'));
    var price = card.querySelector('[data-hs-price]');
    if (price && pill.getAttribute('data-price')) setText(price, pill.getAttribute('data-price'));
    setImage(card, pill.getAttribute('data-img'));
    refreshCard(card);
  }
  function selectColor(card, sw) {
    var color = (sw.getAttribute('data-color') || '').toLowerCase();
    card.querySelectorAll('.swatch-circle').forEach(function (s) { s.classList.toggle('active', s === sw); });
    var first = null, firstAny = null;
    card.querySelectorAll('.size-pill').forEach(function (p) {
      var c = (p.getAttribute('data-color') || '').toLowerCase();
      var show = !c || c === color;
      p.hidden = !show;
      if (!show) p.classList.remove('active');
      if (show && !firstAny) firstAny = p;
      if (show && !first && (p.getAttribute('data-available') === 'true' || isPre(p.getAttribute('data-variant-id')))) first = p;
    });
    var pick = first || firstAny;
    if (pick) selectPill(card, pick);
    setImage(card, sw.getAttribute('data-img'));
  }

  /* ---------------- Add to cart ---------------- */
  function addToCart(btn, vid, available) {
    if (!vid) return;
    if (!available && !isPre(vid)) {
      btn.classList.remove('hs-shake');
      void btn.offsetWidth;
      btn.classList.add('hs-shake');
      return;
    }
    var holder = document.querySelector('product-form.hsc-cc-form');
    var form = holder && holder.querySelector('form');
    if (!form) { window.location.href = '/cart/add?id=' + encodeURIComponent(vid) + '&quantity=1'; return; }
    form.querySelector('input[name="id"]').value = vid;
    btn.disabled = true;
    setText(btn, TEXT.adding);
    closeModal();
    if (form.requestSubmit) form.requestSubmit(); else form.querySelector('[type="submit"]').click();
    setTimeout(function () {
      btn.disabled = false;
      var card = btn.closest('.hsc-cc');
      if (card) refreshCard(card); else setButton(btn, vid, available);
    }, 2000);
  }

  /* ---------------- Modals ---------------- */
  var modal = null;
  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'hs-modal';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML = '<div class="hs-modal__box"><button type="button" class="hs-modal__close" data-hs-close aria-label="' +
      esc(TEXT.close) + '">&times;</button><div class="hs-modal__body"></div></div>';
    document.body.appendChild(modal);
    return modal;
  }
  function openModal(kind, html) {
    var m = ensureModal();
    m.className = 'hs-modal hs-modal--' + kind;
    m.querySelector('.hs-modal__body').innerHTML = html;
    m.hidden = false;
    document.body.style.overflow = 'hidden';
    m.querySelector('.hs-modal__close').focus({ preventScroll: true });
    return m;
  }
  function closeModal() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    modal.querySelector('.hs-modal__body').innerHTML = '';
    document.body.style.overflow = '';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function sgHtml(key, scope) {
    var t = (scope && scope.querySelector('template#hs-sg-' + cssEsc(key))) || document.getElementById('hs-sg-' + key);
    return t ? t.innerHTML : '';
  }
  function cssEsc(s) { return window.CSS && CSS.escape ? CSS.escape(s) : s; }
  function openSizeGuide(key, scope) {
    var html = sgHtml(key, scope);
    if (html) openModal('sg', html);
  }
  function sized(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function openQuickView(card) {
    var m = openModal('qv', '<p class="hs-qv__loading">' + esc(TEXT.loading) + '</p>');
    var url = card.getAttribute('data-url');
    fetch(url.split('?')[0] + '.js').then(function (r) { return r.json(); }).then(function (prod) {
      if (m.hidden) return;
      var prices = {};
      card.querySelectorAll('.size-pill').forEach(function (p) { prices[p.getAttribute('data-variant-id')] = p.getAttribute('data-price'); });
      var fallbackPrice = (card.querySelector('[data-hs-price]') || {}).textContent || '';
      var btn = card.querySelector('[data-hs-add]');
      var current = btn && btn.getAttribute('data-variant-id');
      var variants = prod.variants || [];
      var sel = variants.filter(function (v) { return String(v.id) === String(current); })[0] ||
        variants.filter(function (v) { return v.available; })[0] || variants[0];
      var images = (prod.images && prod.images.length) ? prod.images : [prod.featured_image].filter(Boolean);
      var thumbs = images.map(function (src, i) {
        return '<button type="button" data-hs-qv-thumb="' + i + '"' + (i === 0 ? ' class="active"' : '') + '><img src="' + esc(sized(src, 140)) + '" alt="" loading="lazy"></button>';
      }).join('');
      var mains = images.map(function (src, i) {
        return '<img src="' + esc(sized(src, 900)) + '" alt="' + esc(prod.title) + '" data-hs-qv-img="' + i + '" data-src="' + esc(String(src).split('?')[0]) + '"' + (i ? ' loading="lazy"' : '') + '>';
      }).join('');
      var opts = variants.map(function (v) {
        return '<option value="' + v.id + '" data-available="' + v.available + '" data-img="' + esc(v.featured_image ? String(v.featured_image.src).split('?')[0] : '') + '"' +
          (sel && v.id === sel.id ? ' selected' : '') + '>' + esc(v.title) + ' - ' + esc(prices[v.id] || fallbackPrice) + '</option>';
      }).join('');
      var texts = card.querySelector('template[data-hs-qv-texts]');
      var sgBtn = card.querySelector('[data-hs-sg]');
      var html =
        '<div class="hs-qv">' +
          '<div class="hs-qv__media"><div class="hs-qv__thumbs">' + thumbs + '</div><div class="hs-qv__main">' + mains + '</div></div>' +
          '<div class="hs-qv__details">' +
            '<h2 class="h3">' + esc(prod.title) + '</h2>' +
            '<div class="hs-qv__price" data-hs-qv-price>' + esc((sel && prices[sel.id]) || fallbackPrice) + '</div>' +
            '<a class="hs-qv__link" href="' + esc(url) + '">' + esc(TEXT.details) + '</a>' +
            (texts ? texts.innerHTML : '') +
            (variants.length > 1 ? '<label class="hs-qv__label" for="hs-qv-select">' + esc(TEXT.variant) + '</label>' +
              '<select class="hs-qv__select" id="hs-qv-select" data-hs-qv-select>' + opts + '</select>' :
              '<select hidden data-hs-qv-select>' + opts + '</select>') +
            '<button type="button" class="hs-qv__add" data-hs-qv-add></button>' +
            (sgBtn ? '<button type="button" class="hsc-cc__sg" data-hs-sg="' + esc(sgBtn.getAttribute('data-hs-sg')) + '">' + esc(TEXT.sizeGuide) + '</button>' : '') +
          '</div>' +
        '</div>';
      var body = m.querySelector('.hs-modal__body');
      body.innerHTML = html;
      body.__hsCard = card;
      body.__hsPrices = prices;
      syncQuickView(body, false);
    }).catch(function () {
      if (!m.hidden) window.location.href = url;
    });
  }
  function syncQuickView(body, scroll) {
    var select = body.querySelector('[data-hs-qv-select]');
    var btn = body.querySelector('[data-hs-qv-add]');
    if (!select || !btn) return;
    var opt = select.options[select.selectedIndex];
    if (!opt) return;
    setButton(btn, opt.value, opt.getAttribute('data-available') === 'true');
    var price = body.querySelector('[data-hs-qv-price]');
    if (price && body.__hsPrices[opt.value]) setText(price, body.__hsPrices[opt.value]);
    if (!scroll) return;
    var src = opt.getAttribute('data-img');
    if (!src) return;
    var imgs = body.querySelectorAll('[data-hs-qv-img]');
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].getAttribute('data-src') === src) { scrollQv(body, i); break; }
    }
  }
  function scrollQv(body, i) {
    var main = body.querySelector('.hs-qv__main');
    var img = body.querySelector('[data-hs-qv-img="' + i + '"]');
    if (!main || !img) return;
    if (window.innerWidth < 768) main.scrollTo({ left: img.offsetLeft, behavior: 'smooth' });
    else main.scrollTo({ top: img.offsetTop, behavior: 'smooth' });
    body.querySelectorAll('[data-hs-qv-thumb]').forEach(function (t) { t.classList.toggle('active', t.getAttribute('data-hs-qv-thumb') === String(i)); });
  }

  /* ---------------- Tabs ---------------- */
  var tabCache = {};
  function switchTab(tab) {
    var root = tab.closest('.hsc-collection');
    if (!root) return;
    var handle = tab.getAttribute('data-hsc-tab');
    var panels = root.querySelector('.hsc-tab-panels');
    root.querySelectorAll('.hsc-tab').forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    var show = function (panel) {
      panels.querySelectorAll('.hsc-tab-panel').forEach(function (p) { p.hidden = p !== panel; });
    };
    var existing = panels.querySelector('.hsc-tab-panel[data-hs-panel="' + cssEsc(handle) + '"]');
    if (existing) {
      // Re-insert so hs-preorder.js (which only rescans on added nodes) redraws the legends it
      // dropped while the panel was hidden.
      panels.appendChild(existing);
      show(existing);
      nudgePreorder();
      return;
    }
    if (tabCache[handle]) return;
    tabCache[handle] = true;
    panels.classList.add('is-loading');
    fetchDoc(withSection(tab.getAttribute('data-url'), sectionIdOf(tab))).then(function (doc) {
      var panel = doc.querySelector('.hsc-tab-panel[data-hs-panel="' + cssEsc(handle) + '"]') || doc.querySelector('.hsc-tab-panel');
      if (!panel) throw new Error('no panel');
      panel = document.importNode(panel, true);
      var grid = panel.querySelector('#product-grid');
      if (grid) grid.removeAttribute('id');
      panels.appendChild(panel);
      panels.classList.remove('is-loading');
      if (tab.classList.contains('active')) show(panel); else panel.hidden = true;
      refreshAll(panel);
      nudgePreorder();
    }).catch(function () {
      window.location.href = tab.getAttribute('data-url');
    });
  }

  /* ---------------- Show more / infinite ---------------- */
  function loadMore(btn) {
    if (btn.disabled) return;
    var url = btn.getAttribute('data-hsc-more');
    var scope = btn.closest('.hsc-tab-panel') || btn.closest('.collection') || btn.closest('.hsc-collection');
    var grid = scope && scope.querySelector('[data-hs-grid]');
    if (!grid) return;
    var label = btn.textContent;
    btn.disabled = true;
    setText(btn, TEXT.loading);
    fetchDoc(withSection(url, sectionIdOf(btn))).then(function (doc) {
      var newGrid = doc.querySelector('[data-hs-grid]');
      var items = newGrid ? newGrid.children : [];
      var frag = document.createDocumentFragment();
      Array.prototype.slice.call(items).forEach(function (li) { frag.appendChild(document.importNode(li, true)); });
      var added = frag.childNodes.length;
      grid.appendChild(frag);
      var next = doc.querySelector('[data-hsc-more]');
      if (next && added) {
        btn.setAttribute('data-hsc-more', next.getAttribute('data-hsc-more'));
        btn.disabled = false;
        setText(btn, label);
      } else {
        var wrap = btn.closest('.hsc-more');
        (wrap || btn).remove();
      }
      refreshAll(grid);
      nudgePreorder();
    }).catch(function () {
      btn.disabled = false;
      setText(btn, label);
    });
  }
  var autoObserver = null;
  function watchAuto(root) {
    if (!('IntersectionObserver' in window)) return;
    if (!autoObserver) {
      autoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) loadMore(e.target); });
      }, { rootMargin: '600px 0px' });
    }
    (root || document).querySelectorAll('[data-hsc-more][data-hs-auto]').forEach(function (b) {
      if (b.__hsWatched) return;
      b.__hsWatched = true;
      autoObserver.observe(b);
    });
  }

  /* ---------------- Events ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var el;
    if ((el = t.closest('.hsc-tab[data-hsc-tab]'))) { switchTab(el); return; }
    if ((el = t.closest('[data-hsc-more]'))) { loadMore(el); return; }
    if ((el = t.closest('[data-hs-close]')) || t === modal) { closeModal(); return; }
    if ((el = t.closest('[data-hs-qv-thumb]'))) { scrollQv(el.closest('.hs-modal__body'), +el.getAttribute('data-hs-qv-thumb')); return; }
    if ((el = t.closest('[data-hs-qv-add]'))) {
      var select = el.closest('.hs-modal__body').querySelector('[data-hs-qv-select]');
      var opt = select && select.options[select.selectedIndex];
      if (opt) addToCart(el, opt.value, opt.getAttribute('data-available') === 'true');
      return;
    }
    if ((el = t.closest('[data-hs-sg]'))) {
      var body = el.closest('.hs-modal__body');
      openSizeGuide(el.getAttribute('data-hs-sg'), (body && body.__hsCard) || el.closest('.hsc-cc'));
      return;
    }
    var card = t.closest('.hsc-cc');
    if (!card) return;
    if ((el = t.closest('.swatch-circle'))) { selectColor(card, el); return; }
    if ((el = t.closest('.size-pill'))) { selectPill(card, el); return; }
    if ((el = t.closest('[data-hs-qv]'))) { openQuickView(card); return; }
    if ((el = t.closest('[data-hs-add]'))) {
      var pill = activePill(card);
      addToCart(el, el.getAttribute('data-variant-id'), pill ? pill.getAttribute('data-available') === 'true' : !el.classList.contains('is-sold'));
    }
  });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-hs-qv-select]')) syncQuickView(e.target.closest('.hs-modal__body'), true);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) document.querySelectorAll('[data-hs-add]').forEach(function (b) { b.disabled = false; });
    refreshAll(document);
  });

  function boot() {
    readText();
    refreshAll(document);
    watchAuto(document);
    loadPreorder();
    // Filters/sorting (facets.js) replace the grid: re-apply state to the new cards.
    var pending = null;
    document.querySelectorAll('.hsc-collection').forEach(function (root) {
      new MutationObserver(function (records) {
        var relevant = records.some(function (r) {
          return Array.prototype.some.call(r.addedNodes, function (n) { return n.nodeType === 1 && (n.matches('.hsc-cc, li, .collection') || n.querySelector && n.querySelector('.hsc-cc')); });
        });
        if (!relevant || pending) return;
        pending = setTimeout(function () { pending = null; refreshAll(root); watchAuto(root); nudgePreorder(); }, 150);
      }).observe(root, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
